module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAVFBMVEUAAAAzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzPEWWtkAAAAG3RSTlMA0/T2/LgR886w78CLXn/YCurfpch1GI9OQS/HeaciAAAArUlEQVQ4y+XUyw6DIBCFYUEExCp47eW8/3vWBklsxnZcGDf+C8LiW0AIk107bU2+pBBTubGaQKuwkbIEGjixJNF2XefghIMhUMKnbYV6XhuUmYfcgIJCcRzUz7ALVhLtsAdC3B14WAyP+QHGtudgSBsOZsfBqS9W9dNPWGDVv1vX6qv6xMuE5hZ7MbDEUs7AMUHBnTHo2NlP6Cn0EZLvSiLflRkAZKSQPiPl0r0BS90VDTvbGLMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-top8.png
// module id = itVo
// module chunks = 21